"use client";

import Link from "next/link";
import { TenKGameProvider } from "@/components/dashboard/metrics-games/tenk-game-context";
import { MetricsGamesContent } from "@/components/dashboard/metrics-games-content";

export function MetricsPlayground() {
  return (
    <TenKGameProvider>
    <main className="container metrics-playground-page">
      <section className="hero hero--left">
        <p className="section-label">Metrics lab</p>
        <h1>Interactive Metrics Playground</h1>
        <p className="hero-sub">
          Change inputs, see the formulas run, and learn exactly how each NICHEMRR metric is calculated.
        </p>
        <p className="hero-meta">
          <Link href="/dashboard/opportunities" className="inline-link">
            Back to leaderboard
          </Link>
        </p>
      </section>

      <section className="metrics-games">
        <MetricsGamesContent
          tenkSearchInCard
          opportunityScoreSearchInCard
          scoreDeltaSearchInCard
        />
      </section>
    </main>
    </TenKGameProvider>
  );
}
